// 平台船运需求

import UltMeta, { Meta } from "./UltMeta/index";

class State extends UltMeta {
    TO_BE_ALLOCATED = new Meta(1, "已发布");
    ENDED = new Meta(2, "已结束");
    CLOSED = new Meta(3, "已关闭");
}

export const STATE = new State();

/**
 * 接单状态
 */
class OrderAcceptanceState extends UltMeta {
    PENDING_PROCESSING = new Meta(0, "待处理");
    CONFIRMED = new Meta(1, "--");
}

export const ORDER_ACCEPTANCE_STATE = new OrderAcceptanceState();

/**
 * 排水槽
 */
class DrainageChannel extends UltMeta {
    NO_DRAINAGE_CHANNEL = new Meta(1, "无水槽");
    DRAINAGE_CHANNEL_FAIR = new Meta(2, "水槽一般");
    DRAINAGE_CHANNEL_GOOD = new Meta(3, "水槽好");
}
export const DRAINAGE_CHANNEL = new DrainageChannel();

/**
 * 船务小程序船运需求标签
 */
class RouteTag extends UltMeta {
    SMART_MATCH = new Meta(1, "智能匹配");
    FREQUENT_ROUTE = new Meta(2, "常跑航线");
    HISTORICAL_ROUTE = new Meta(3, "历史航线");
}

export const ROUTE_TAG = new RouteTag();

/**
 * 电联号码类型
 */
class ElectricContactNumberType extends UltMeta {
    PHONE = new Meta(1, "手机号");
    LANDLINE = new Meta(2, "座机");
}

export const ELECTRIC_CONTACT_NUMBER_TYPE = new ElectricContactNumberType();
